'use client'

import CustomerQuote from '@/components/CustomerQuote'

const FortoCaseStudyQuoteTwo = () => {
    return (
        <CustomerQuote
            backgroundImageSrc={'/images/forto-case-study/customer-quote-2-lg.png'}
            mobileBackgroundImageSrc={'/images/forto-case-study/customer-quote-2-sm.png'}
            text={
                <>
                    By partnering with Lune, emission visibility becomes a market differentiator
                    that helps Forto win business and build stronger relationships with our
                    customers.
                </>
            }
            avatar={{
                title: 'Renate Härle',
                subtitle: 'Director of Marketing at Forto',
                imageSrc: '/images/forto-case-study/customer-quote-2-avatar.png',
            }}
            reversedOnMobile
        />
    )
}

export default FortoCaseStudyQuoteTwo
